<div (click)="toggleTooltip()" class="sgc-legend-container">
  <mat-icon svgIcon="info-bold" class="sgc-legend-trigger-icon"></mat-icon>
  <span class="sgc-legend-trigger-title">Legend</span>
</div>

<div *ngIf="tooltipVisible" class="sgc-legend-tooltip-container" @tooltipAnimation>
  <div class="sgc-legend-tooltip-arrow"></div>
  <div class="sgc-legend-tooltip-contents">
    <span class="sgc-legend-tooltip-title">Milestone viewer key</span>
    <div class="sgc-legend-tooltip-body">
      <div class="sgc-legend-tooltip-top-row">
        <div class="sgc-legend-tooltip-top-row-item">
          <span class="sgc-legend-tooltip-top-row-icon">
            <mat-icon svgIcon="diamond" class="sgc-legend-tooltip-top-diamond-icon"></mat-icon>
          </span>
          <mat-icon svgIcon="dash-medium" class="sgc-legend-tooltip-top-row-dash"></mat-icon>
          <span class="sgc-legend-tooltip-top-row-label">Milestone marker</span>
        </div>
        <div class="sgc-legend-tooltip-top-row-item">
          <span class="sgc-legend-tooltip-top-row-icon">
            <mat-icon svgIcon="bar" class="sgc-legend-tooltip-top-bar-icon"></mat-icon>
          </span>
          <mat-icon svgIcon="dash-medium" class="sgc-legend-tooltip-top-row-dash"></mat-icon>
          <span class="sgc-legend-tooltip-top-row-label">Milestone group and study stage</span>
        </div>
      </div>

      <ng-container *ngFor="let legend of milestoneViewerTooltipLegends">
        <div class="sgc-legend-tooltip-legend-row-item">
          <span class="sgc-legend-tooltip-legend-row-label">{{ legend.label }}</span>
          <span class="sgc-legend-tooltip-legend-row-description">{{ legend.description }}</span>
          <div class="sgc-legend-tooltip-legend-row-icons">
            <mat-icon
              [svgIcon]="legend.icon"
              [style.color]="legend.iconColor"
              class="sgc-legend-tooltip-legend-icon"
            ></mat-icon>
            <mat-icon
              svgIcon="diamond"
              [style.color]="legend.iconColor"
              class="sgc-legend-tooltip-diamond-icon"
            ></mat-icon>
            <mat-icon
              *ngIf="legend.barIcon"
              [svgIcon]="legend.barIcon"
              class="sgc-legend-tooltip-bar-icon"
            ></mat-icon>
          </div>
        </div>
      </ng-container>
      <span class="sgc-legend-tooltip-note"
        >*Some milestone group statuses are automatically calculated based on performance against a
        key KPI.</span
      >
    </div>
  </div>
</div>
